import ApiService from "../api";

export default class RecolhimentoAtivosService extends ApiService {

    constructor() {
        super('/api/solicitacoes/recolhimento-ativos')
    }

    criarSolicitacao(dados) {
        return this.post(``, dados)
    }

    buscarDetalhe(solicitacaoId) {
        return this.get(`/${solicitacaoId}`)
    }

    relatorio(filtros = {}) {
        const params = new URLSearchParams();
        Object.entries(filtros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        return this.get(`/relatorio?${params}`);
    }

    dashboard(filtros = {}) {
        const params = new URLSearchParams();
        Object.entries(filtros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        return this.get(`/dashboard?${params}`);
    }
}
